import React, { useRef } from 'react';
import { Box } from '@landr/maestro';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import FiltersAndInput from './components/FiltersAndInput/FiltersAndInput';
import Suggestions from './components/Suggestions/Suggestions';

const _SearchBar = ({
    suggestionRef,
    isModal,
    isSuggestionsOpen,
    closeSuggestions,
    hasSuggestions,
    isTrendingVisible,
}: {
    suggestionRef: React.RefObject<HTMLDivElement>;
    isModal: boolean;
    isSuggestionsOpen: boolean;
    closeSuggestions: () => void;
    hasSuggestions: boolean;
    isTrendingVisible: boolean;
}) => (
    <>
        {!isModal && isSuggestionsOpen && (
            <Box
                position="fixed"
                width="100%"
                height="100%"
                top="0"
                left="0"
                backgroundColor="transparent"
                onClick={closeSuggestions}
            />
        )}
        <FiltersAndInput
            triggerRef={suggestionRef}
            isModal={isModal}
            isSuggestionsOpen={isSuggestionsOpen}
            isBottomRadiusZero={hasSuggestions || isTrendingVisible}
        />
        <Suggestions
            anchorRef={suggestionRef}
            isModal={isModal}
            isTrendingVisible={isTrendingVisible}
        />
    </>
);

const SearchBar = () => {
    const ref = useRef<HTMLDivElement>(null);
    const {
        isSuggestionsOpen,
        closeSuggestions,
        hasSuggestions,
        handleKeyPress,
        isModal,
        isTrendingVisible,
    } = useSearchBarContext();

    return (
        <Box onKeyDown={handleKeyPress} position="relative">
            <_SearchBar
                suggestionRef={ref}
                isModal={isModal}
                isSuggestionsOpen={isSuggestionsOpen}
                closeSuggestions={closeSuggestions}
                hasSuggestions={hasSuggestions}
                isTrendingVisible={isTrendingVisible}
            />
        </Box>
    );
};

SearchBar.displayName = 'Filters.SearchBar';

export default SearchBar;
